module.exports = __webpack_public_path__ + "static/media/bistecca-cover.af2fc0a3.jpg";